import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";

function Error() {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="error">
      <div className="error-code">404</div>
      <div className="error-content">
        <div className="error-message">No pudimos encontrarlo...</div>
        <div className="error-desc mb-4">
          La página que estás buscando no existe. <br />
          Quizás, estas páginas te ayudarán a encontrar lo que buscas.
        </div>
        <div>
          <Link to="/" className="btn btn-success px-3">
            Ir a Inicio
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Error;
